// removed by extract-text-webpack-plugin
module.exports = {"footer":"Footer__footer___1-DWm","dropdown-container":"Footer__dropdown-container___23_xA","item-dropdown":"Footer__item-dropdown___aTv3o"};